export const toTwoDigitsNumber = number =>
  number <= 9 ? `0${number}` : String(number);

export function convertMMSSToSS(durationStr) {
  if (!durationStr) {
    return 0;
  }

  return _(durationStr)
    .split(':')
    .reverse()
    .reduce(function(duration, chunk, i) {
      return duration + chunk * Math.pow(60, i);
    }, 0);
}

export function convertISO8601ToMMSS(durationStr) {
  if (!durationStr) {
    return '00:00';
  }

  let [, ...parts] = durationStr.match(
    /^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/,
  );
  parts = _.map(parts, part => Number(part) || 0);

  const days = parts[0];
  let [, hours, minutes, seconds] = parts;
  [hours, minutes, seconds] = _.map(
    [days * 24 + hours, minutes, seconds],
    toTwoDigitsNumber,
  );

  if (hours === '00') {
    return `${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}:${seconds}`;
}

export const convertISO8601ToSS = durationStr =>
  durationStr ? convertMMSSToSS(convertISO8601ToMMSS(durationStr)) : 0;

export function convertSSToMMSS(durationSec) {
  durationSec = Math.floor(durationSec || 0);

  const chunks = [];

  do {
    chunks.unshift(toTwoDigitsNumber(durationSec % 60));

    durationSec = Math.floor(durationSec / 60);
  } while (durationSec > 0);

  if (chunks.length < 2) {
    chunks.unshift('00');
  }

  return chunks.join(':');
}
